import { apiPost } from "./client";

export interface OrderTrackingLink {
  token: string;
  createdAt?: string | null;
  expiresAt?: string | null;
}

export async function createOrderTrackingLink(
  accessToken: string,
  workspaceId: string,
  orderId: string,
): Promise<OrderTrackingLink> {
  const response = await apiPost(
    accessToken,
    `/api/orders/${orderId}/tracking-link`,
    {},
    workspaceId,
  );
  return response.data as OrderTrackingLink;
}

export function buildPublicTrackingUrl(token: string): string {
  return `${window.location.origin}/track#${encodeURIComponent(token)}`;
}

export function isOrderTrackingEnabledForWorkspace(
  workspaceId?: string,
): boolean {
  if (!workspaceId) return false;
  const enabledWorkspaceIds = (
    process.env.REACT_APP_PUBLIC_ORDER_TRACKING_WORKSPACE_IDS || ""
  )
    .split(",")
    .map((value) => value.trim())
    .filter(Boolean);
  return (
    enabledWorkspaceIds.includes("*") ||
    enabledWorkspaceIds.includes(workspaceId)
  );
}
